import { smallImageHeight } from '@components/imageHandling/common';
import { isPhone } from '@helpers';
import { StyleSheet } from 'react-native';
import { notchTop } from '@components/frame';

export const THUMBNAIL_WIDTH = isPhone ? 20 : 87;
export const ACTIVE_THUMBNAIL_WIDTH = isPhone ? 58 : 100;
export const THUMBNAIL_HEIGHT = smallImageHeight;

export const ACTIVE_THUMBNAIL_HEIGHT = THUMBNAIL_HEIGHT;

export const THUMBNAIL_MARGIN = StyleSheet.hairlineWidth;
export const ACTIVE_THUMBNAIL_MARGIN = 11;

export const NAVIGATION_ARROW_SIZE = 36;

export const mapDocumentTypeSvg: Record<string, { icon: string; width: number; height: number }> = {
  '2D Drawing': { icon: 'twoDDrawing', width: 19, height: 19 },
  '3D Drawing': { icon: 'threeDDrawing', width: 16, height: 19 },
  'General Document': { icon: 'other', width: 14, height: 18 },
  Image: { icon: 'partImage', width: 16, height: 18 },
  'Clamping Image': { icon: 'clampingImage', width: 18, height: 20 },
  'Inspection Result': { icon: 'measurements', width: 14, height: 18 },
  'Maintenance Procedure': { icon: 'setup', width: 19, height: 18 },
  'Material Certificate': { icon: 'material', width: 17, height: 20 },
  'Measurement Report': { icon: 'measurements', width: 14, height: 18 },
  'Purchase Order': { icon: 'salesOrder', width: 17, height: 19 },
  'Production Order': { icon: 'productionOrder', width: 20, height: 10 },
  'Setup Sheet': { icon: 'setup', width: 19, height: 18 },
  'Test Specification': { icon: 'measurements', width: 14, height: 18 },
};

export const TTL_FOR_IMAGE = 2 * 60 * 1000;

export const FORCE_RETRIEVE_FROM_SOURCE_KEY_EXPIRATION_TIME = 'forceRetrieveFromSourceKey';
export const IMAGE_ZOOM_CONSTRAINTS = { min: 1, max: 5 };

export const CROPPER_WEB_HEADER_HEIGHT = 40;
export const CROPPER_WEB_MAX_WIDTH = 1314;

export const ATTACH_ITEMS_ON_TOP_OFF_IMAGE_TOP = 18;
export const ATTACH_ITEMS_ON_TOP_OFF_IMAGE_LEFT = 18;

export const EXPANDABLE_IMAGE_SCREEN_PATTERNS = ['Documents', 'OperatorPanelInformation'];

export const IMAGE_HANDLING_POPUP_ID = 'image-handling-modal';

/**
 * Fallback safe-area top inset for platforms / devices that report `notchTop === 0`
 * (non-notch iOS hardware, simulators, Android). Matches the historical 22 used across
 * the image-handling Header components.
 */
export const IMAGE_HANDLING_PLATFORM_TOP_FALLBACK = 22;

/**
 * Effective safe-area top inset used across the image-handling module — uses the platform's
 * notch height when available, falls back to {@link IMAGE_HANDLING_PLATFORM_TOP_FALLBACK}
 * otherwise so floating bars never overlap the system status line on non-notch hardware.
 */
export const SAFE_TOP_INSET = notchTop || IMAGE_HANDLING_PLATFORM_TOP_FALLBACK;
